import * as fs from "fs";
import * as ko from "knockout";
import * as moment from "moment";
import { Utils } from "../../utils";
import { RNSAPI } from "../../api";
import { Postbox, PostboxPaging } from '../postbox/postbox';
import './dialog';
import './message';
import { MainViewModel } from "../../main";
export class editAppointmentDialogViewModel {
    modalMode = ko.observable(0);
    appointmentToBeModified = ko.observable(null);
    showLoadingError = ko.observable(false);
    fKAId = ko.observable('');
    fkAName = ko.observable('');
    savedSuccessfull = ko.observable(false);
    showError = ko.observable(false);
    showSuccess = ko.observable(false);
    showLoader = ko.observable(false);
    notifyVerifyDeadline = ko.observable(false);
    rejectionReason = ko.observable('');
    showRejection = ko.observable(false);
    optionEntries = ko.observableArray(["Ablehnung durch Gericht vom " + moment().format("DD.MM.YYYY")]);
    completionReason = ko.observable<string>("");
    deletionReason = ko.observable<string>("");
    viewWithoutModal = ko.observable(false);
    isStack = ko.observable(false);
    mailId = ko.observable(null);
    attachmentId = ko.observable(0);
    handleResponses(response, appointmentObj, isRejection: boolean = false) {
        let result = response as any;
        this.savedSuccessfull(true);
        this.showLoader(false);
        if (appointmentObj.WasExportedToOutlook) {
            if (result.OutlookExport === "SUCCESS") {
                this.showError(false);
                this.showSuccess(true);
            }
            else if (result.OutlookExport === "FAILURE") {
                this.showSuccess(false);
                this.showError(true);
            }
            else {
                this.showError(false);
                this.showSuccess(false);
            }
        }
        setTimeout(() => {
            Postbox.publisher().publish("", "updateTFW");
            if (ko.toJS(this.showError) === false) {
                this.savedSuccessfull(false);
                this.showLoader(false);
                this.showError(false);
                this.showSuccess(false);
                if (!this.viewWithoutModal())
                    $('#editAppointmentModal').modal('hide');
                if (isRejection) {
                    Postbox.publisher().publish(appointmentObj.Id, "FillAppointmentDataWithID");
                    $("#AppointmentVerificationmodal").modal("show");
                }
                if (ko.toJS(this.mailId) !== null)
                    PostboxPaging.publisher().publish("", "GetEntriesInStackCreation");
            }
        }, 2000);
    }
    async showRejectStep() {
        this.showRejection(true);
        this.rejectionReason("");
    }
    async abortRejectStep() {
        this.showRejection(false);
    }
    async verifyStep() {
        this.showLoader(true);
        await RNSAPI.verifyAppointment(this.appointmentToBeModified().Id, ko.toJS(this.mailId), ko.toJS(this.attachmentId)).then((response) => {
            this.handleResponses(response, this.appointmentToBeModified());
        }).catch((error) => {
            alert("Fehler beim Speichern.");
            this.showLoader(false);
        });
    }
    async rejectStep() {
        if (!ko.toJS(this.rejectionReason)) {
            $("#reasonForRejection_inp").addClass("has-error");
            return;
        }
        $("#reasonForRejection_inp").removeClass("has-error");
        this.showLoader(true);
        await RNSAPI.rejectAppointment(this.appointmentToBeModified().Id, ko.toJS(this.rejectionReason), ko.toJS(this.mailId), ko.toJS(this.attachmentId)).then((response) => {
            this.handleResponses(response, this.appointmentToBeModified(), true);
        }).catch((error) => {
            alert("Fehler beim Speichern.");
            this.showLoader(false);
        });
    }
    async mapAppointment(id) {
        this.savedSuccessfull(false);
        this.showLoader(false);
        this.showError(false);
        this.showSuccess(false);
        this.showRejection(false);
        this.showLoadingError(false);
        if (!this.viewWithoutModal())
            $("#editAppointmentModal").modal('show');
        await RNSAPI.getAppointment(id).then((response) => {
            let obj = response.Payload.Appointment as any;
            obj.AppointmentTypeFormated = obj.AppointmentType.Name ? obj.AppointmentType.Name : "Unbekannte Terminart";
            obj.StartFormated = ko.toJS(moment(ko.toJS(obj.StartDate)).format("DD.MM.YYYY HH:mm")) + " Uhr";
            obj.EndFormated = ko.toJS(moment(ko.toJS(obj.EndDate)).format("DD.MM.YYYY HH:mm")) + " Uhr";
            if (ko.toJS(obj.StartFormated).endsWith("00:00 Uhr") && ko.toJS(obj.EndFormated).endsWith("23:59 Uhr")) {
                obj.StartFormated = ko.toJS(moment(ko.toJS(obj.StartDate)).format("DD.MM.YYYY"));
                obj.EndFormated = ko.toJS(moment(ko.toJS(obj.EndDate)).format("DD.MM.YYYY"));
            }
            this.appointmentToBeModified(obj);
        }).catch((error) => {
            console.log(error);
            this.showLoadingError(true);
            this.appointmentToBeModified(null);
        });
    }
    async completeAppointment() {
        this.showLoader(true);
        await RNSAPI.completeAppointment(this.appointmentToBeModified().Id, ko.toJS(this.mailId), ko.toJS(this.attachmentId)).then((response) => {
            this.handleResponses(response, this.appointmentToBeModified());
        }).catch((error) => {
            alert("Fehler beim Erledigen.");
            this.showLoader(false);
        });
    }
    async deleteAppointment() {
        if (ko.toJS(this.deletionReason) === "") {
            $("#deleteReasonContainer").addClass("has-error");
            return;
        }
        else {
            $("#deleteReasonContainer").removeClass("has-error");
        }
        this.showLoader(true);
        await RNSAPI.deleteAppointment(ko.toJS(this.appointmentToBeModified().Id), ko.toJS(this.deletionReason), ko.toJS(this.mailId), ko.toJS(this.attachmentId)).then((response) => {
            this.handleResponses(response, this.appointmentToBeModified());
        }).catch((error) => {
            alert("Fehler beim Löschen.");
            this.showLoader(false);
        });
    }
    constructor(params: any) {
        params = params || {};
        if (Object.prototype.hasOwnProperty.call(params, 'showWithoutModal'))
            this.viewWithoutModal(ko.toJS(params.showWithoutModal));
        if (Object.prototype.hasOwnProperty.call(params, 'isStack'))
            this.isStack(ko.toJS(params.isStack));
        if (Object.prototype.hasOwnProperty.call(params, 'MailId'))
            this.mailId(ko.toJS(params.MailId));
        if (Object.prototype.hasOwnProperty.call(params, 'AttachmentId'))
            this.attachmentId(ko.toJS(params.AttachmentId));
        if (params.appointmentId)
            this.mapAppointment(ko.toJS(params.appointmentId));
        PostboxPaging.publisher().subscribe((appointmnetData) => {
            this.appointmentToBeModified(null);
            this.completionReason("");
            this.deletionReason("");
            this.modalMode(appointmnetData.Mode);
            this.mapAppointment(appointmnetData.Appointment.Id);
        }, "EditAppointmentModalData");
    }
    dispose() {
        PostboxPaging.publisher().unsubscribe("EditAppointmentModalData");
    }
}
let html = fs.readFileSync(__dirname + "/editAppointmentDialog.html", "utf8");
ko.components.register("edit-appointment-dialog-view", {
    viewModel: editAppointmentDialogViewModel,
    template: html,
});
